import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';

// TODO: Replace with your Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;

// Only initialize Firebase if config is available
const hasFirebaseConfig = Object.values(firebaseConfig).every(value => value !== '');

if (hasFirebaseConfig) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    console.log('✅ Firebase initialized successfully');
  } catch (error) {
    console.warn('⚠️ Firebase initialization failed:', error);
  }
} else {
  console.warn('⚠️ Firebase config not found. Running in development mode with mock auth.');
}

export { app, auth, db };
export const isFirebaseConfigured = hasFirebaseConfig;

/**
 * Update user subscription status in Firestore
 */
export const updateUserSubscription = async (
  userId: string,
  subscriptionData: {
    subscriptionActive: boolean;
    subscriptionId?: string;
    stripeCustomerId?: string;
    subscriptionStatus?: string;
    subscriptionTier?: 'individual' | 'district';
  }
) => {
  if (!db || !isFirebaseConfigured) {
    console.warn('Firebase not configured - subscription update skipped');
    return;
  }

  try {
    const { doc, updateDoc } = await import('firebase/firestore');
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      ...subscriptionData,
      updatedAt: new Date(),
    });
    console.log('✅ Updated user subscription in Firestore');
  } catch (error) {
    console.error('❌ Error updating user subscription:', error);
    throw error;
  }
};
